import {Component, OnInit} from '@angular/core';
import {PaymentService} from '../../../shared/services/payment.service';
import {GlobalService} from '../../../shared/services/global.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../../shared/services/alert.service';
import {OrganisationService} from '../../../shared/services/organisation.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from "../../../shared/services/auth.service";

@Component({
  selector: 'app-pricing-and-plans',
  templateUrl: './pricing-and-plans.component.html',
  styleUrls: ['./pricing-and-plans.component.scss'],
  providers: [GlobalService, PaymentService, OrganisationService, AuthService]
})
/*export class PricingAndPlansComponent implements OnInit {
  user: any

  Testimonial = [
    {
      description:
        'Your stuff is awesome! Needless to say we are extremely satisfied with the results and will recommend to my anyone I know.',
      imageSrc: '/assets/img/avatars/2.jpg',
      name: 'Preetam Singh',
      designation: 'CTO',
      starCount: 4
    },
    {
      description:
        'It\'s perfect. No matter where you go, you always know it\'s the coolest, most happening thing around! We\'ve used it for the last five years.',
      imageSrc: '/assets/img/avatars/3.jpg',
      name: 'Abhishek Jaiswal',
      designation: 'Registrar',
      starCount: 5
    },
    {
      description:
        'This is worth much more than I paid. If you want real marketing that works and effective implementation - they got you covered.',
      imageSrc: '/assets/img/avatars/5.jpg',
      name: 'Amrita Pant',
      designation: 'CFO',
      starCount: 5
    },
    {
      description:
        'This is the next killer app. We have no regrets! Best app for specialized tooling. Thanks guys, keep up the good work!',
      imageSrc: '/assets/img/avatars/4.jpg',
      name: 'Sameera Arora',
      designation: 'Manager',
      starCount: 4
    },
  ];
  amount: number;
  planForm: FormGroup;
  finalPlans: any;
  selectedPlanType: any;
  selectedPlanOverview: any;

  constructor(private router: Router,
              private organisationService: OrganisationService,
              private fb: FormBuilder,
              private alertService: AlertService,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.refresh();
    this.planForm = this.fb.group({
      selectedPlan: ['Monthly', Validators.required]
    });
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
      }
    });
  }

  refresh(): void {
    this.organisationService.getPlans().subscribe(data => {
      if (data && data.length > 0) {
        let planTypeArr: any = [];
        data.forEach((plan) => {
          if (!(planTypeArr.includes(plan.type))) {
            planTypeArr.push(plan.type);
          }
        });
        if (planTypeArr.length > 0) {
          this.finalPlans = [];
          planTypeArr.forEach(plantype => {
            let plans = [];
            data.forEach(plan => {
              if (plan.type === plantype) {
                let status = false;
                if (plan.overview == 'Monthly') {
                  status = true;
                }
                plans.push({
                  'overview': (plan && plan.overview) ? plan.overview : '',
                  'name': (plan.name) ? plan.name : '',
                  'price': (plan && plan.price) ? plan.price : 0,
                  'discounted_price': (plan && plan.discounted_price) ? plan.discounted_price : 0,
                  'description': (plan && plan.description) ? plan.description : '',
                  'users': (plan && plan.users) ? plan.users : 0,
                  'plan_id': plan.unique_id,
                  'status': status
                });
              }
            });
            if (plans.length > 0) {
              this.finalPlans.push({type: plantype, plans: plans});
            }
          });
        }
      }
    });
  }

  onChange(type: any, SelectedPlan: any): void {
    this.finalPlans.forEach((item: any) => {
      if (item.type == type) {
        item.plans.forEach(plan => {
          plan.status = plan.overview == SelectedPlan;

        });
      }
      this.selectedPlanType = type;
      this.selectedPlanOverview = SelectedPlan;
    });
  }

  goToCheckOut(id: any): void {
    const user: any = JSON.parse(localStorage.getItem('self'));
    if (user && user.user_id && user.user_type === 'ORGANISATION') {
      this.router.navigate(['/checkout', id]);
    } else {
      this.router.navigateByUrl('/auth/login');
    }
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }

  getStarsArray(starCount: number): number[] {
    return Array(starCount).fill(0);
  }

  notAllowed() {
    this.alertService.showErrors('You have exceeded the user limit and cannot choose this plan.');
  }



  getIconClass(duration: string): string {
    const iconMap = {
      'Monthly': 'fas fa-calendar-month',
      'Quarterly': 'fas fa-calendar-quarter',
      'Half-Yearly': 'fas fa-calendar-six',
      'Yearly': 'fas fa-calendar-year'
    };
    return iconMap[duration] || 'fas fa-calendar';
  }

  getIconTitle(duration: string): string {
    const titleMap = {
      'Monthly': 'Great Choice! Get Started',
      'Quarterly': 'Best Value! Start Now',
      'Half-Yearly': 'Advanced Plan! Get More',
      'Yearly': 'Ultimate Plan! Big Savings'
    };
    return titleMap[duration] || 'Plan Details';
  }

  getSelectedPlanDetails(): {iconClass: string, iconTitle: string} {
    const selectedPlan = this.finalPlans.flatMap(planType => planType.plans)
      .find(plan => plan.status);
    return {
      iconClass: selectedPlan ? this.getIconClass(selectedPlan.overview) : '',
      iconTitle: selectedPlan ? this.getIconTitle(selectedPlan.overview) : ''
    };
  }

  getPlanBackgroundColor(plan: any): string {
    return plan.status ? 'bg-light-gray' : '';
  }

}*/

export class PricingAndPlansComponent implements OnInit {
  user: any;
  finalPlans: any;
  selectedPlanType: string;
  selectedPlanOverview: string;
  planForm: FormGroup;
  planType: any;  // Ensure this is correctly initialized
  selectedDuration: any;
  planDurations = {
    Monthly: 'Monthly Bliss',
    Quarterly: 'Quarterly Advantage',
    HalfYearly: 'Half-Yearly Triumph',
    Yearly: 'Yearly Excellence'
  };
  Testimonial = [
    {
      description:
        'Your stuff is awesome! Needless to say we are extremely satisfied with the results and will recommend to my anyone I know.',
      imageSrc: '/assets/img/avatars/18291.jpg',
      name: 'Preetam Singh',
      designation: 'CTO',
      starCount: 4
    },
    {
      description:
        'It\'s perfect. No matter where you go, you always know it\'s the coolest, most happening thing around! We\'ve used it for the last five years.',
      imageSrc: '/assets/img/avatars/11.jpg',
      name: 'Abhishek Jaiswal',
      designation: 'Registrar',
      starCount: 5
    },
    {
      description:
        'This is worth much more than I paid. If you want real marketing that works and effective implementation - they got you covered.',
      imageSrc: '/assets/img/avatars/Pasted image.png',
      name: 'Amrita Pant',
      designation: 'CFO',
      starCount: 5
    },
    {
      description:
        'This is the next killer app. We have no regrets! Best app for specialized tooling. Thanks guys, keep up the good work!',
      imageSrc: '/assets/img/avatars/15.jpg',
      name: 'Sameera Arora',
      designation: 'Manager',
      starCount: 4
    },
  ];

  constructor(private router: Router,
              private organisationService: OrganisationService,
              private fb: FormBuilder,
              private alertService: AlertService,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.refresh();
    this.planForm = this.fb.group({
      selectedPlan: ['Monthly Bliss', Validators.required]
    });
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
      }
    });
  }

  refresh(): void {
    this.organisationService.getPlans().subscribe(data => {
      if (data && data.length > 0) {
        let planTypeArr: any = [];
        data.forEach((plan) => {
          if (!(planTypeArr.includes(plan.type))) {
            planTypeArr.push(plan.type);
          }
        });
        if (planTypeArr.length > 0) {
          this.finalPlans = [];
          planTypeArr.forEach(plantype => {
            let plans = [];
            data.forEach(plan => {
              if (plan.type === plantype) {
                let status = plan.overview === 'Monthly Bliss';
                plans.push({
                  'overview': plan.overview || '',
                  'name': plan.name || '',
                  'price': plan.price || 0,
                  'discounted_price': plan.discounted_price || 0,
                  'description': plan.description || '',
                  'users': plan.users || 0,
                  'plan_id': plan.unique_id,
                  'icon_class': plan.icon_class,
                  'icon_text' : plan.icon_text,
                  'status': status,
                });
              }
            });
            if (plans.length > 0) {
              this.finalPlans.push({type: plantype, plans: plans});
            }
          });
        }
      }
    });
  }

  onChange(type: any, SelectedPlan: any): void {
    this.finalPlans.forEach((item: any) => {
      if (item.type === type) {
        item.plans.forEach(plan => {
          plan.status = plan.overview === SelectedPlan;
        });
        this.selectedPlanType = type;
        this.selectedDuration = SelectedPlan;
      }
    });
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }

  getColorClass(overview: string): string {
    switch (overview) {
      case 'Monthly Bliss':
        return 'text-green';
      case 'Quarterly Advantage':
        return 'text-blue';
      case 'Half Yearly Triumph':
        return 'text-pink';
      case 'Yearly Excellence':
        return 'text-orange';
      default:
        return '';
    }
  }
  getIconClass(planType: string, duration: string): string {
    switch (duration) {
      case 'Monthly':
        return planType === 'Basic' ? 'fa fa-star' : planType === 'Standard' ? 'fa fa-star-half-alt' : 'fa-regular fa-face-grin-stars';
      case 'Quarterly':
        return planType === 'Basic' ? 'fa fa-star-half-alt' : planType === 'Standard' ? 'fa fa-trophy' : 'fa fa-star-o';
      case 'Half Yearly':
        return planType === 'Basic' ? 'fa fa-trophy' : planType === 'Standard' ? 'fa fa-star-o' : 'fa-solid fa-medal';
      case 'Yearly':
        return planType === 'Basic' ? 'fa fa-star-o' : planType === 'Standard' ? 'fa fa-star' : 'fa fa-trophy';
      default:
        return '';
    }
  }

  getIconTitle(planType: string, duration: string): string {
    switch (duration) {
      case 'Monthly':
        return planType === 'Basic' ? 'Great Start' : planType === 'Standard' ? 'Super Saver' : 'Ultimate Choice';
      case 'Quarterly':
        return planType === 'Basic' ? 'Smart Investment' : planType === 'Standard' ? 'Savvy Saver' : 'Power Play';
      case 'Half Yearly':
        return planType === 'Basic' ? 'Wise Choice' : planType === 'Standard' ? 'Pro Advantage' : 'Elite Edge';
      case 'Yearly':
        return planType === 'Basic' ? 'Top Value' : planType === 'Standard' ? 'Premier Deal' : 'Supreme Choice';
      default:
        return '';
    }
  }

  notAllowed() {
    this.alertService.showErrors('You have exceeded the user limit and cannot choose this plan.');
  }

  goToCheckOut(id: any): void {
    const user: any = JSON.parse(localStorage.getItem('self'));
    if (user && user.user_id && user.user_type === 'ORGANISATION') {
      this.router.navigate(['/checkout', id]);
    } else {
      this.router.navigateByUrl('/auth/login');
    }
  }

  getStarsArray(starCount: number): number[] {
    return Array(starCount).fill(0);
  }


  getPlanBackgroundColor(plan: any): string {
    return plan.status ? 'bg-light-gray' : '';
  }
}

